import {ReportModel} from "@fedeltapointofsale/data-client";
import {DetailedSalesReportData} from "./detailed-sales-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class DetailedSalesReportModel extends ReportModel<DetailedSalesReportData> {
    constructor(injector: Injector) {
        super(injector, DetailedSalesReportData);
    }
}
